import Image from 'next/image';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
import { useRedeemedReward } from 'root/src/client/web/giveaway/features/RedeemedRewardsModal/hooks/useRedeemedReward';
import { ToggleableCopyField, } from 'root/src/client/web/base/ToggleableCopyField/ToggleableCopyField';
export const RedeemedReward = (props) => {
    const { reward, index, total } = props;
    const { decryptedRewardQuery, rewardURL, rewardCTA } = useRedeemedReward(reward);
    return (<div className="flex flex-col justify-center items-center gap-6">
			<h1 className="text-center uppercase font-mono text-2xl font-bold max-w-sm">
				{reward.name}
			</h1>
			<span className="text-xs text-center text-light-5 uppercase">
				YOUR REWARD IS BELOW. THIS IS SOME HELPFUL TEXT COMMUNICATION TO<br />TELL THEM WHAT TO DO NEXT
			</span>
			<div className="rounded-lg border border-teal overflow-hidden flex">
				<Image src={reward.image} width={200} height={210} alt={reward.name}/>
			</div>
			<div className="flex flex-col justify-center items-center gap-2">
				<span className="text-teal">{reward.name}</span>
				<span className="tracking-widest text-lg">{index} / {total}</span>
			</div>
			{decryptedRewardQuery.data && <ToggleableCopyField text={decryptedRewardQuery.data}/>}
			<ButtonNew>
				{decryptedRewardQuery.isLoading ? <LoadingCircles width={40} height={40}/> : (<a href={addHttpsProtocol(rewardURL)} target="_blank" rel="noreferrer">
						<span className="uppercase font-bold">{rewardCTA}</span>
					</a>)}
			</ButtonNew>
		</div>);
};
